class AudioManager {
  constructor() {
    this.context = null;
    this.isMuted = false;
    this.masterGain = null;
  }

  init() {
    if (!this.context) {
      const AudioContext = window.AudioContext || window.webkitAudioContext;
      this.context = new AudioContext();
      
      // Create master gain node
      this.masterGain = this.context.createGain();
      this.masterGain.connect(this.context.destination);
      this.masterGain.gain.value = this.isMuted ? 0 : 0.3;
    }

    if (this.context.state === 'suspended') {
      this.context.resume();
    }
  }

  setMuted(muted) {
    this.isMuted = muted;
    if (this.masterGain) {
      this.masterGain.gain.setValueAtTime(
        muted ? 0 : 0.3,
        this.context.currentTime
      );
    }
  }

  toggleMute() {
    this.setMuted(!this.isMuted);
    return this.isMuted;
  }

  playTone(freq, type = 'sine', duration = 0.1, vol = 0.1) {
    if (this.isMuted || !this.context) return;

    if (this.context.state === 'suspended') {
      this.context.resume();
    }

    const osc = this.context.createOscillator();
    const gain = this.context.createGain();

    osc.type = type;
    osc.frequency.setValueAtTime(freq, this.context.currentTime);

    gain.gain.setValueAtTime(vol, this.context.currentTime);
    gain.gain.exponentialRampToValueAtTime(
      0.01,
      this.context.currentTime + duration
    );

    osc.connect(gain);
    gain.connect(this.masterGain);

    osc.start();
    osc.stop(this.context.currentTime + duration);
  }

  playPop() {
    this.playTone(400 + Math.random() * 200, 'sine', 0.15, 0.2);
  }

  playHit() {
    this.playTone(300, 'sine', 0.08, 0.1);
  }

  playStart() {
    if (this.isMuted || !this.context) return;
    const now = this.context.currentTime;
    this.playTone(200, 'triangle', 0.5, 0.2);
    setTimeout(() => this.playTone(400, 'triangle', 0.4, 0.15), 100);
    setTimeout(() => this.playTone(600, 'triangle', 0.3, 0.1), 200);
  }

  playGameOver() {
    if (this.isMuted || !this.context) return;
    this.playTone(600, 'sawtooth', 0.5, 0.2);
    setTimeout(() => this.playTone(400, 'sawtooth', 0.5, 0.2), 300);
    setTimeout(() => this.playTone(200, 'sawtooth', 0.8, 0.2), 600);
  }

  playSpecial() {
    if (this.isMuted || !this.context) return;
    this.playTone(800, 'sine', 0.1, 0.2);
    setTimeout(() => this.playTone(1200, 'sine', 0.3, 0.15), 100);
  }

  playLevelUp() {
    if (this.isMuted || !this.context) return;
    this.playTone(400, 'sine', 0.1, 0.2);
    setTimeout(() => this.playTone(800, 'sine', 0.1, 0.2), 100);
    setTimeout(() => this.playTone(600, 'sine', 0.1, 0.2), 200);
    setTimeout(() => this.playTone(1000, 'sine', 0.2, 0.2), 300);
  }

  playAchievement() {
    if (this.isMuted || !this.context) return;
    this.playTone(600, 'sine', 0.2, 0.2);
    setTimeout(() => this.playTone(900, 'sine', 0.2, 0.2), 200);
    setTimeout(() => this.playTone(1200, 'triangle', 0.4, 0.15), 400);
  }

  playExplode() {
    if (this.isMuted || !this.context) return;

    const noise = this.context.createBufferSource();
    const buffer = this.context.createBuffer(
      1,
      this.context.sampleRate * 0.5,
      this.context.sampleRate
    );
    const data = buffer.getChannelData(0);

    for (let i = 0; i < buffer.length; i++) {
      data[i] = Math.random() * 2 - 1;
    }

    const gainNode = this.context.createGain();
    const filter = this.context.createBiquadFilter();

    filter.type = 'lowpass';
    filter.frequency.value = 400;

    noise.buffer = buffer;
    noise.connect(filter);
    filter.connect(gainNode);
    gainNode.connect(this.masterGain);

    gainNode.gain.setValueAtTime(0.5, this.context.currentTime);
    gainNode.gain.exponentialRampToValueAtTime(
      0.01,
      this.context.currentTime + 0.5
    );

    noise.start();
  }
}

export const audioManager = new AudioManager();